if (!customElements.get("ona-phrase-rotator")) {
  customElements.define(
    "ona-phrase-rotator",
    class OnaPhraseRotator extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.interval = 2e3;
        this.attachShadow({ mode: "open" });
      }
      connectedCallback() {
        const shadow = this.shadowRoot;
        shadow.innerHTML = `
          <style>
            :host {
              display: flex;
              position: relative;
              height: calc(var(--ona-phrase-rotator-line-height, 1em) * var(--ona-phrase-rotator-visible-lines, 3));
              overflow: hidden;
            }

            :host::before, :host::after {
              content: "";
              position: absolute;
              left: 0;
              width: 100%;
              height: var(--ona-phrase-rotator-line-height, 1em);
              z-index: 10;
            }

            :host::before {
              top: 0;
              background-image: linear-gradient(to bottom, var(--ona-phrase-rotator-bg-color, white), transparent 50%);
            }

            :host::after {
              bottom: 0;
              background-image: linear-gradient(to top, var(--ona-phrase-rotator-bg-color, white), transparent 50%);
            }

            ::slotted(ul) {
              transition: translate 500ms;
              translate: 0 calc(var(--ona-phrase-rotator-line-height, 1em) * var(--ona-phrase-rotator-active-index, 0) * -1);
            }
          </style>
          <slot></slot>
        `;
        const slot = this.shadowRoot.querySelector("slot");
        const slottedElements = slot.assignedElements({ flatten: true });
        this._endingList = slottedElements.find((el) => el.tagName === "UL");
        this._endingItems = Array.from(this._endingList.querySelectorAll("li"));
        let tempLi = this._endingItems.at(-1).cloneNode(true);
        tempLi.setAttribute("aria-hidden", "true");
        this._endingList.prepend(tempLi);
        tempLi = this._endingItems.at(0).cloneNode(true);
        tempLi.setAttribute("aria-hidden", "true");
        this._endingList.append(tempLi);
        this._endingItems.push(tempLi);
        tempLi = this._endingItems.at(1).cloneNode(true);
        tempLi.setAttribute("aria-hidden", "true");
        this._endingList.append(tempLi);
        this._endingItems.push(tempLi);
        this._updateVisibleItems();
        this.startRotation();
      }
      startRotation() {
        this.stopRotation();
        this.intervalId = setInterval(() => {
          this.nextItem();
        }, this.interval);
      }
      stopRotation() {
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }
      nextItem() {
        this.currentIndex = (this.currentIndex + 1) % (this._endingItems.length - 1);
        this._updateVisibleItems();
      }
      _rollToLine(index) {
        this._endingItems.at(index - 1).classList.remove("active");
        this._endingItems.at(index).classList.add("active");
        this.style.setProperty("--ona-phrase-rotator-active-index", index);
      }
      _updateVisibleItems() {
        const isRollingBack = this.currentIndex === this._endingItems.length - 2;
        this._rollToLine(this.currentIndex);
        if (isRollingBack) {
          setTimeout(() => {
            const firstItem = this._endingItems.at(0);
            this._endingList.style.transition = "none";
            firstItem.style.setProperty("--ona-phrase-rotator-item-force-transition", "none");
            this._rollToLine(0);
            this._endingList.offsetHeight;
            firstItem.offsetHeight;
            firstItem.style.setProperty("--ona-phrase-rotator-item-force-transition", "");
            this._endingList.style.transition = "";
            this._endingItems.at(this.currentIndex).classList.remove("active");
            this.currentIndex = 0;
          }, 600);
        }
      }
    }
  );
}
